import sharedCss from '../shared/shared.styles';

export default (theme: Object) => ({
  screenContainer: {
    ...sharedCss.screenContainer,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  screenTitle: {
    ...sharedCss.screenTitle(theme),
    textAlign: 'center',
    marginBottom: 24,
  },
  verificationMessage: {
    lineHeight: '1.29',
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.semantic.alert,
    marginBottom: '20px',
  },
});
